import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List, Button, Tooltip } from 'antd';
import { comparisonActions } from '../../store/slices/comparison.slice';
import { RestoreRounded, DeleteOutlineRounded } from '@mui/icons-material';
import { format } from 'date-fns';

const PerformanceComparisonHistory = () => {
  const dispatch = useDispatch();
  const { history } = useSelector(state => state.comparison);

  const handleRestore = (historyId) => {
    dispatch(comparisonActions.restoreFromHistory(historyId));
  };

  const handleRemove = (historyId) => {
    dispatch(comparisonActions.removeHistoryEntry(historyId));
  };

  const formatTimestamp = (timestamp) => {
    return format(new Date(timestamp), 'MMM d, yyyy HH:mm');
  };

  return (
    <div className="p-4">
      <List
        size="small"
        dataSource={[...history].reverse()} // Show newest first
        renderItem={(entry) => (
          <List.Item
            key={entry.id}
            actions={[
              <Tooltip title="Restore this comparison">
                <Button
                  icon={<RestoreRounded />}
                  onClick={() => handleRestore(entry.id)}
                  type="text"
                  size="small"
                />
              </Tooltip>,
              <Tooltip title="Remove from history">
                <Button
                  icon={<DeleteOutlineRounded />}
                  onClick={() => handleRemove(entry.id)}
                  type="text"
                  size="small"
                  danger
                />
              </Tooltip>
            ]}
          >
            <List.Item.Meta
              title={formatTimestamp(entry.timestamp)}
              description={
                <div className="text-sm text-gray-500">
                  {entry.items.map(item => item.label).join(', ')}
                </div>
              }
            />
          </List.Item>
        )}
        locale={{ emptyText: 'No history entries' }}
        className="max-h-96 overflow-y-auto"
      />
      {history.length > 0 && (
        <div className="mt-4 text-right">
          <Button
            onClick={() => dispatch(comparisonActions.clearHistory())}
            type="text"
            danger
            size="small"
          >
            Clear History
          </Button>
        </div>
      )}
    </div>
  );
};

export default PerformanceComparisonHistory;